import { createContext, useContext } from 'react';
import type { UmgebungSummary } from '@etown/shared';
import type { GameRuntime } from '../../game/GameRuntime';
import type { AppSocket } from '../../net/socketClient';
import type { RtcManager } from '../../webrtc/RtcManager';

export interface OfficeServices {
  socket: AppSocket;
  runtime: GameRuntime;
  rtc: RtcManager;
  mapId: string;
  /** Die betretene Umgebung samt eigener Rolle. */
  umgebung: UmgebungSummary;
  /** Admin dieser Umgebung oder Superadmin. */
  istAdmin: boolean;
  /** `theme`-Feld der Karte — entscheidet, ob der 3D-Stil waehlbar ist. */
  mapTheme: string;
}

/** Zugriff auf Socket/Runtime/RTC fuer alle Office-Unterkomponenten. */
export const OfficeContext = createContext<OfficeServices | null>(null);

export function useOffice(): OfficeServices {
  const ctx = useContext(OfficeContext);
  if (!ctx) throw new Error('useOffice ausserhalb von OfficeContext verwendet');
  return ctx;
}
